





















































import { ColumnsModel, TableFilterModel } from '@/types';
import { ColumnFilterType } from '@/types/enums/ColumnFilterType';
import { ArrayUtils } from '@/utils';
import { EnumUtils } from '@/utils/enumUtils';
import Vue, { PropType } from 'vue';
import MStoreSpinnerButton from '../MStoreSpinnerButton.vue';

export default Vue.extend({
  name: 'MStoreColumnFilter',
  data() {
    return {
      isFilterOptionsDirty: false as boolean
    };
  },
  props: {
    size: {
      type: String
    },
    fields: {
      type: Array as PropType<ColumnsModel[]>,
      required: true
    },
    filterOptions: {
      type: Array as PropType<TableFilterModel[]>,
      required: true
    }
  },
  methods: {
    updateFilterValue(index: number, value: string) {
      this.updateFilter(index, { ...(this.filterOptions as TableFilterModel[])[index], value });
    },
    clearFilterValue(index: number) {
      this.updateFilter(index, { ...(this.filterOptions as TableFilterModel[])[index], value: '' });
    },
    updateFilterKey(index: number, key: string) {
      this.updateFilter(index, { ...(this.filterOptions as TableFilterModel[])[index], key });
    },
    updateColumnFilterType(index: number, columnFilterType: ColumnFilterType) {
      this.updateFilter(index, { ...(this.filterOptions as TableFilterModel[])[index], columnFilterType });
    },
    updateFilter(index: number, filter: TableFilterModel) {
      this.$emit('update:update-filter', index, { ...filter });
      this.isFilterOptionsDirty = true;
    },
    addFilter(this: any) {
      this.$emit('update:add-filter');
      this.isFilterOptionsDirty = true;
    },
    clearFilters(this: any) {
      this.$emit('update:clear-filters');
      this.isFilterOptionsDirty = true;
    },
    resetFilters(this: any) {
      this.$emit('update:reset-filters');
      this.isFilterOptionsDirty = false;
    },
    removeFilter(this: any, index: number) {
      this.$emit('update:remove-filter', index);
      if (this.filterOptions.length < 1) {
        this.resetFilters();
      } else {
        this.isFilterOptionsDirty = true;
      }
    },
    applyFilters(this: any) {
      this.$emit('update:apply-filtering');
      this.isFilterOptionsDirty = false;
    },
    getFilterOptions(this: any, key: string) {
      const allFilterOptions = this.fields as ColumnsModel[];
      const usedFilterKeys = (this.filterOptions as TableFilterModel[]).map((x) => x.key);
      const availableFilterKeys = allFilterOptions.map((x) => x.key).filter((x) => !usedFilterKeys.includes(x));
      return [this.DEFAULT_FILTER_OPTION, ...allFilterOptions.filter((option) => [key, ...availableFilterKeys].includes(option.key))];
    },
    setDirty(this: any) {
      this.isFilterOptionsDirty = true;
    }
  },
  computed: {
    columnFilterTypes(this: any) {
      return [this.DEFAULT_COLUMN_FILTER_TYPE_OPTION, ...ArrayUtils.alphabeticalSort(EnumUtils.getEnumValues(ColumnFilterType), (x) => x.description!)];
    },
    hasFilter(this: any) {
      return (this.filterOptions as TableFilterModel[]).length > 0;
    },
    maxFiltersReached(this: any) {
      return (this.filterOptions as TableFilterModel[]).length === this.fields.length;
    },
    filtersCanBeReset(this: any) {
      return this.hasFilter || (this.filterOptions as TableFilterModel[]).some(({ key, value, columnFilterType }) => key || value || columnFilterType);
    },
    filtersCanBeCleared(this: any) {
      return (this.filterOptions as TableFilterModel[]).some(({ value }) => value);
    },
    filtersArePopulated(): boolean {
      return (this.filterOptions as TableFilterModel[]).every((filter: TableFilterModel) => filter.key && filter.value && filter.columnFilterType);
    }
  },
  created(this: any) {
    this.DEFAULT_FILTER_OPTION = { key: '', label: 'Select Field', disabled: true };
    this.DEFAULT_COLUMN_FILTER_TYPE_OPTION = { key: '', description: 'Select Filter Type', disabled: true };
  },
  components: {
    MStoreSpinnerButton
  }
});
